import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Lib
import H2 from '@/components/base/Headings/H2';
// Type
import type { ReportFormProps } from '@/components/pages/reports/CreateEditPage/components/ReportForm';

type PageHeaderProps = Pick<ReportFormProps, 'isEdit'>;

const PageHeader = ({ isEdit = false }: PageHeaderProps) => {
    const { t } = useTranslation();
    return (
        <header className={clsx('z-10 pb-10')} aria-label="Progress">
            <H2>{t(isEdit ? 'reports:general.edit_report' : 'reports:general.create_report')}</H2>
        </header>
    );
};

export default PageHeader;
